import React, { useRef, useState } from 'react';
import { Grid, TextField, Typography, Button, FormControl, InputLabel, Select, MenuItem, Backdrop, CircularProgress, Box, Checkbox, FormControlLabel, Link } from "@mui/material";
import BranchSelect from './branchSelect';
import PartnershipField from './partnership';
import StateSelect from './states';
import handleSubmission from '../utils/formSubmission';
import InputMask from 'react-input-mask';

function FormComponent({ setPage, campaign, campaign_details, show_how_did_you_hear, partnership }) {
    const firstNameRef = useRef();
    const lastNameRef = useRef();
    const emailRef = useRef();
    const [phone, setPhone] = useState('');
    const phoneRef = useRef();
    const branchRef = useRef();
    const benefitStatusRef = useRef();
    const campaignDetailsRef = useRef()
    const stateRef = useRef()
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState("")
    const [termsAccepted, setTermsAccepted] = useState(false);

    const handleTermsChange = (event) => {
        setTermsAccepted(event.target.checked);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (submitting || !termsAccepted) return;
        setError("")
        setSubmitting(true);

        // Start a timer at the beginning of the function
        const startTime = Date.now();
        let campaignDetails
        try{
            if(campaign_details != null && campaign_details != ""){
                campaignDetails = campaign_details
            } else {
                campaignDetails = campaignDetailsRef.current?.value
            }
        }catch(e){}

        const data = {
            first_name: firstNameRef.current?.value,
            last_name: lastNameRef.current?.value,
            email: emailRef.current?.value,
            phone: phoneRef.current?.value, // Not required
            military: branchRef.current?.value,
            benefits: benefitStatusRef.current?.value,
            campaign,
            campaign_details: campaignDetails,
            state: stateRef.current?.value,
            partnership
        };

        // console.log(data);

        try {
            const submission = await handleSubmission(data, setPage);
            if (submission === 409) {
                setError("Email Already In Use!");
            }
        } catch (e) {
            setPage("error");
        }

        // Calculate how long the function has been running
        const elapsedTime = Date.now() - startTime;

        // If it's been less than 2 seconds, wait the difference
        if (elapsedTime < 2000) {
            await new Promise(resolve => setTimeout(resolve, 2000 - elapsedTime));
        }

        setSubmitting(false);
    };


    return (
        <Box position="relative" sx={{ maxWidth: '600px', margin: 'auto'}}>
            <form id="vbg_form" onSubmit={handleSubmit} style={{ maxWidth: "600px" }}>
                <Grid container item xs={12}>

                    {/* First Name */}
                    <Grid item xs={12} sm={6} sx={{p:2, py:1}}>
                        <Typography sx={{ color: "white" }}>First Name*</Typography>
                        <TextField sx={{ background: "white", borderRadius: 1 }} size="small" fullWidth required inputRef={firstNameRef} />
                    </Grid>

                    {/* Last Name */}
                    <Grid item xs={12} sm={6} sx={{p:2, py:1}}>
                        <Typography sx={{ color: "white" }}>Last Name*</Typography>
                        <TextField sx={{ background: "white", borderRadius: 1 }} size="small" fullWidth required inputRef={lastNameRef} />
                    </Grid>

                    {/* Email */}
                    <Grid item xs={12} sm={6} sx={{p:2, py:1}}>
                        <Typography sx={{ color: error != "" ? "red" : "white" }}>Email*</Typography>
                        <TextField sx={{ background: "white", borderRadius: 1 }} error={error != ""} size="small" fullWidth required type="email" inputRef={emailRef} />
                        {
                            error != "" ?
                            <Typography sx={{ color:"red" }}>{error}</Typography>
                            : null
                        }
                    </Grid>

                    {/* Phone */}
                    <Grid item xs={12} sm={6} sx={{p:2, py:1}}>
                        <Typography sx={{ color: "white" }}>Phone</Typography>
                        <InputMask
                            mask="(999) 999-9999"
                            value={phone}
                            onChange={(event) => setPhone(event.target.value)} // Update the state on change
                            ref={phoneRef} // Set the ref on InputMask if needed for focus or other imperative actions
                        >
                            {() =>
                                <TextField
                                    sx={{ background: "white", borderRadius: 1 }}
                                    size="small"
                                    fullWidth
                                    value={phone} // Set the value from state
                                />
                            }
                        </InputMask>
                    </Grid>

                    {/* Branch */}
                    <Grid item xs={12} sm={6} sx={{p:2, py:1}}>
                        <Typography sx={{ color: "white" }}>Branch*</Typography>
                        <BranchSelect branchRef={branchRef} />
                    </Grid>

                    {/* Benefit Status */}
                    <Grid item xs={12} sm={6} sx={{p:2, py:1}}>
                        <FormControl fullWidth required>
                            <Typography sx={{ color: "white" }}>Benefits Status*</Typography>
                            <Select
                                size="small"
                                id="benefits"
                                name="benefits"
                                defaultValue=""
                                inputRef={benefitStatusRef}
                                sx={{ background: "white", borderRadius: 1 }}
                                displayEmpty
                            >
                                <MenuItem value="">-- Please Choose an Option --</MenuItem>
                                <MenuItem value="new_claim">Never Filed</MenuItem>
                                <MenuItem value="not_service_connected">Not Service Connected</MenuItem>
                                <MenuItem value="Zero">0%</MenuItem>
                                <MenuItem value="10">10%</MenuItem>
                                <MenuItem value="20">20%</MenuItem>
                                <MenuItem value="30">30%</MenuItem>
                                <MenuItem value="40">40%</MenuItem>
                                <MenuItem value="50">50%</MenuItem>
                                <MenuItem value="60">60%</MenuItem>
                                <MenuItem value="70">70%</MenuItem>
                                <MenuItem value="80">80%</MenuItem>
                                <MenuItem value="90">90%</MenuItem>
                                <MenuItem value="100">100%</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Custom Partnership Field */}
                    {
                        show_how_did_you_hear == true || show_how_did_you_hear == 'yes' ? 
                        <PartnershipField partnershipField={campaign} campaignDetailsRef={campaignDetailsRef} show_how_did_you_hear={show_how_did_you_hear} />
                        : null
                    }

                    <Grid container item xs={12} sm={6} sx={{p:2, py:1}}>
                        <StateSelect stateRef={stateRef} />
                    </Grid>

                    {/* Terms and Conditions Checkbox */}
                    <Grid container item xs={12} justifyContent="center">
                        <FormControlLabel
                            sx={{ color: "white" }}
                            control={
                                <Checkbox
                                  checked={termsAccepted}
                                  onChange={handleTermsChange}
                                  name="termsAndConditions"
                                  sx={{
                                    color: 'black', // default color
                                    '&.Mui-checked': {
                                      color: '#128ACD', // color of the checkmark when the checkbox is checked
                                    },
                                    '& .MuiSvgIcon-root': { // targets the icon
                                      borderRadius: 1, // optional, for rounded corners
                                      boxShadow: '0px 0px 0px 1px black inset', // creates a black border
                                      backgroundColor: 'white', // white background color
                                      
                                    },
                                    '.Mui-focusVisible &': {
                                      outline: 'none',
                                    },
                                  }}
                                />
                              }
                            label="Yes, I accept the Terms & Conditions of this site."
                        />
                    </Grid>

                    {/* Submit Button */}
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item xs={5}>
                            <Button
                                fullWidth
                                size="small"
                                variant="contained"
                                sx={{
                                    backgroundColor: submitting || !termsAccepted ? 'grey' : '#128ACD',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: submitting || !termsAccepted ? 'grey' : '#128ACD',
                                    },
                                }}
                                type="submit"
                            >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>


                    {/* Links */}
                    <Grid container item justifyContent="center" sx={{ mt: 1 }}>
                        <Typography variant="body2" color="white">
                            <Link href="https://vbg.com/privacy-policy" color="inherit" sx={{ mr: 2 }}>Privacy Policy</Link> 
                            <Link href="https://vbg.com/ccpa-privacy-notice" color="inherit" sx={{ mr: 2 }}>CCPA Privacy Notice</Link> 
                            <Link href="https://vbg.com/terms-conditions" color="inherit" sx={{ mr: 2 }}>Terms & Conditions</Link> 
                            <Link href="https://vbg.com/disclaimer" color="inherit">Disclaimer</Link>
                        </Typography>
                    </Grid>

                </Grid>
            </form>

            {/* Loading Overlay */}
            {submitting && (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', zIndex: 10 }}
                >
                    <CircularProgress />
                </Box>
            )}
        </Box>

    );
}

export default FormComponent;
